import type { SaleResource } from '@src/domains/sale-items';

/** Joins each resource formatted label (e.g. seat or table name) into one display line. */
export const formatReservationResources = (resources: SaleResource[] | null | undefined): string | null => {
  const names = (resources ?? []).map((saleResource) => saleResource.resource.formattedName).filter(Boolean);

  return names.length ? names.join(', ') : null;
};
